<template>
  <div class="time-indicator rounded">
    <span class="remaining" v-if="timeRemaining >= 0"><i class="material-icons">hourglass_empty</i> {{timeRemainingConverted}} remaining</span>
    <div class="time-bar" :style="{'--time': duration+'s'}" :class="urgency"></div>
  </div>
</template>

<script>
export default {
  name: 'time-indicator',
  props: ['duration'],
  data () {
    return {
      timeRemaining: null
    }
  },
  mounted () {
  this.timeRemaining = this.duration
  this.countDown();
  },
  methods: {
    countDown () {
      if ( this.timeRemaining >= 0 ) {
        setTimeout(() => {
          this.timeRemaining--
          this.countDown();
        }, 1000);
      }
    }
  },
  computed: {
    timeRemainingConverted () {
      const format = val => `0${Math.floor(val)}`.slice(-2)
      let timeArray = [];
      if (this.timeRemaining > 3600) {
        timeArray.push(this.timeRemaining / 3600)  
      } 
      timeArray.push((this.timeRemaining % 3600) / 60);
      timeArray.push(this.timeRemaining % 60);

      return timeArray.map(format).join(':')
    },
    urgency () {
      const percentageRemaining =  this.timeRemaining / this.duration * 100;
      if ( percentageRemaining < 10 ) {
        return 'urgent'
      } else if ( percentageRemaining < 25 ) {
        return 'medium'
      }
      return 'normal';
    }
  }
}
</script>

<style lang="scss" scoped>
.time-indicator {
  position: relative;
  width: 100%;
  height: 18px;
  background-color: #3d3dde;
  display: flex;
  align-items: center;
  background: repeating-linear-gradient(
        -45deg,
        #fff,
        #fff 5px,
        #3d3dde 5px,
        #3d3dde 10px
      );
  animation: move-background 2s linear infinite;

  i {
    position: relative;
    z-index: 10;
    color: #fff;
    font-size: 14px;
    margin-right: 5px;
  }
  .remaining {
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 10;
    // margin-left: auto;
    margin-right: auto;
    font-size: 10px;
    color: #fff;
    text-shadow: 0px 0px 3px #000;
    background-color: darken(#3d3dde, 20%);
    padding: 0 15px 0 10px;
  }

  .time-bar {
    flex: 1;
    display: block;
    height: 100%;
    transform: scaleX(0);
    animation: fill-time linear;
    animation-fill-mode: both;
    animation-duration: var(--time);
    transform-origin: 0% 50%;
    
    transition: all 2s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;
    
    &.normal {
      background-color: #3d3dde;
    }
    &.medium {
      background-color: #e1651d;
    }
    &.urgent {
      background-color: #e1241d;
    }
  }
}

@keyframes fill-time {
    from {
        transform: scaleX(0);
    }
    to {
        transform: scaleX(1);
    }
}
@keyframes move-background {
  from {
    background-position: 0;
  }
  to {
    background-position: 14px;
  }
}
</style>